import { CheekSwabType } from '@nkr/views/cheek-swab-request-form';

export interface ICheekSwabModal {
    show: boolean,
    type: CheekSwabType
}